import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './UnderlinedButton.css';

class UnderlinedButton extends Component {
  constructor() {
    super();
    this.beforeAction = this.beforeAction.bind(this);
  }

  beforeAction() {
    const { beforeAction } = this.props;

    if (beforeAction) {
      beforeAction();
    }

    return true;
  }

  render() {
    const { title, redirect, whiteMode } = this.props;
    let modifierClass = '';

    if (whiteMode) {
      modifierClass = 'white-mode';
    }

    return (
      <Link
        to={redirect}
        className={`underlined-button ${modifierClass}`}
        onClick={this.beforeAction}
      >
        <span>{title}</span>
        <div className="underline-arrow">
          <div className="arrow-body" />
          <i className="arrow-head" />
        </div>
      </Link>
    );
  }
}

UnderlinedButton.propTypes = {
  title: PropTypes.string.isRequired,
  redirect: PropTypes.string.isRequired,
  whiteMode: PropTypes.bool,
  beforeAction: PropTypes.func,
};

UnderlinedButton.defaultProps = {
  whiteMode: false,
  beforeAction: null,
};

export default UnderlinedButton;
